import { render, staticRenderFns } from "./OP_IIPrintable.vue?vue&type=template&id=27b1c442&scoped=true&"
import script from "./OP_IIPrintable.vue?vue&type=script&lang=js&"
export * from "./OP_IIPrintable.vue?vue&type=script&lang=js&"
import style0 from "./OP_IIPrintable.vue?vue&type=style&index=0&id=27b1c442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1c442",
  null
  
)

export default component.exports